import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import { primaryButton } from './engagement-submission.helper';
import { copyToClipboard } from '../../../intake/common/intake.util';
import { Size, SpinnerThemes } from '@usitsdasdesign/dds-ng/shared';
import {
  getStatusEnumKeyByValue,
  GlobalEngagementsConstant,
} from '../../constants/global-engagements.constants';
import { GlobalEngagementService } from '../../../http/global-engagement/global-engagement.service';
import {
  debounceTime,
  filter,
  Observable,
  Subject,
  switchMap,
  takeUntil,
} from 'rxjs';
import {
  GlobalDocumentTableModel,
  GlobalEngagementSubmissionDetailModel,
  GlobalEngagementSubmissionLevelModel,
  GlobalEngEfaModel,
  GlobalEngEfaModelWithPagination,
} from '../../../common/models/global-engagement.model';
import { HttpErrorResponse } from '@angular/common/http';
import { IAutosaverOptions, Saver } from '../../../common/autosaver/saver';
import { AutosaverService } from '../../../common/autosaver/autosaver.service';
import { SelectItemOptions } from '@usitsdasdesign/dds-ng/select';
import { ProgressIndicatorService } from '../../../common/services/progress-indicator.service';
import { PermissionsObj } from '../../../common/models/common-models';
import { SubmissionActionHistoryModel } from '../../../common/models/submission-action.model';
import { SHOW_MORE_BTN_OPTIONS } from '../../global-engagement.helper';
import { ButtonComponent } from '@usitsdasdesign/dds-ng/button';
import { ModalService } from '@usitsdasdesign/dds-ng/modal';
import { DiscontinuePopupComponent } from './discontinue-popup/discontinue-popup.component';
import { IntakeConstant } from '../../../intake/constants/intake.constant';
import { StatusEnum } from '../../../common/constants/status-enum';
import { CommonService } from '../../../http/intake/common.service';
import { WbsWithArchiveDetailsModelForGlobalEngagements } from '../../../common/models/wbs-picker.model';
import { hasValue } from '../../../common/utils/common-util';
import { DocumentService } from '../../../http/document/document.service';
import { Router } from '@angular/router';
import { ToastService } from '@usitsdasdesign/dds-ng/toast';
import {
  GlobalEngagementSubmissionDocumentStatus,
  GlobalEngagementSubmissionStatusMapper,
} from '../../constants/global_engagement_submission_status.enum';
import { GlobalEngResetStatusComponent } from './global-eng-reset-status/global-eng-reset-status.component';
import { SubmissionFormValidEmitter } from '../../../common/models/external-communication.model';
import { SharedConstant } from '../../../common/constants/shared.constant';
import { SearchOptions } from '@usitsdasdesign/dds-ng/search';
import { SpinnerOptions } from '@usitsdasdesign/dds-ng/spinner';
import { BrowserTabConstant } from '../../../common/constants/browser-tab-constant';
enum CallFromEnum {
  fromInit = 0,
  fromScroll = 1,
}

@Component({
  selector: 'app-engagement-submission',
  templateUrl: './engagement-submission.component.html',
  styleUrl: './engagement-submission.component.less',
})
export class EngagementSubmissionComponent implements OnDestroy {
  @Input() submissionId: number | null = null;
  @Input() submissionStatus: string | null = null;
  @Input() submissionType: string | null = null;
  @Input() permissionObj: PermissionsObj = {} as PermissionsObj;
  @Input() engagementId: number | null = null;
  @Output() loadLeftMenu: EventEmitter<number | null> = new EventEmitter<
    number | null
  >();
  @Output() isEngagementDetailsFormValid: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() isValidForm: EventEmitter<SubmissionFormValidEmitter> =
    new EventEmitter<SubmissionFormValidEmitter>();

  _BLANK: string = SharedConstant.EMPTY_STRING;
  primaryLoudButton = primaryButton;
  htmlElementSize: Size = SharedConstant.UI_ELEMENT_SIZE_LG;
  readonly #unsubscriber$: Subject<void> = new Subject<void>();
  submissionDetails: GlobalEngagementSubmissionDetailModel | null = null;
  engagementTitle: string | null | undefined = null;
  isEngagementTitleEditable: boolean = false;
  public savedetails!: Saver | null;
  notes: string | null | undefined = null;
  submissionTypeId: number | null | undefined = null;
  submissionStatusId: number | null | undefined = null;
  isWBSEditable: boolean = false;
  isWbsSelected: boolean = false;
  isArchiveEditable: boolean = false;
  efaList: SelectItemOptions[] = [];
  efaSelectedId: string | undefined | null = null;
  isEfaEditable: boolean = false;
  isWbsAvailable: boolean = false;
  defaultValue = SharedConstant.DEFAULT_FOR_EMPTY_FIELDS;

  submissionActionHistory: SubmissionActionHistoryModel[] = [];
  showDiscontinueMessage: boolean = false;
  discontinueActionMessage?: SubmissionActionHistoryModel;
  resetActionMessage?: SubmissionActionHistoryModel;
  isShowMoreDocumentNotes: boolean = false;
  showMoreOptions: any = SHOW_MORE_BTN_OPTIONS;
  private timeoutId: ReturnType<typeof setTimeout> | null = null;
  showMoreText: string = IntakeConstant.SHOW_MORE_TEXT;
  wbsArchiveFormdata: WbsWithArchiveDetailsModelForGlobalEngagements = {};
  totalDocCount: number = 0;
  showResetActionMessage: boolean = false;
  isWbsArchiveEditProgress: boolean = true;
  isEngagementDetailsCompleted: boolean | undefined = false;
  lastButtonEnableStatus: boolean | undefined;
  efaSelected: string = SharedConstant.DEFAULT_FOR_EMPTY_FIELDS;
  efaTotalCount: number = 0;
  pageNumber: number = 1;
  onScrollDataLoadInProgress: boolean = false;
  showEfaDropdown: boolean = false;
  totalSearchResultLoaded: number = 0;
  efaNotFound: string = this._BLANK;
  searchOptions: SearchOptions = {
    placeholder: 'Search EFA',
    size: Size.md,
    customClass: this._BLANK,
  };
  spinnerOptions: SpinnerOptions = {
    theme: SpinnerThemes.gray,
    thickness: '0.188rem',
    size: '1.875rem',
    customClass: this._BLANK,
    isInverse: false,
  };
  isEfaSpinnerVisible: boolean = false;
  readonly #searchEfaQuery$: Subject<string> = new Subject<string>();
  efaArr: GlobalEngEfaModel[] = [];

  constructor(
    private readonly globalEngagementService: GlobalEngagementService,
    private readonly autosaverService: AutosaverService,
    private readonly progressIndicator: ProgressIndicatorService,
    private readonly commonService: CommonService,
    private readonly modalService: ModalService,
    private readonly documentService: DocumentService,
    private readonly router: Router,
    private readonly toastService: ToastService
  ) {}

  ngOnInit(): void {

    document.title = BrowserTabConstant.Browser_TabName_GlobalEngagements;
    this.globalEngagementService.discontinueCloseModal$.subscribe((status) => {
      if (status) {
        this.openModalForDiscontinue();
      }
    });
    this.globalEngagementService.resetStatusModal$.subscribe((status) => {
      if (status) {
        this.openModalForResetStatus();
      }
    });

    let autoSaverOptions = {
      onSuccess: (
        saver: any,
        result: GlobalEngagementSubmissionLevelModel
      ) => {},
    } as IAutosaverOptions;

    this.savedetails = this.autosaverService.newSaver(
      'savedetails',
      this,
      async () => this.postEngagementDetails(),
      autoSaverOptions
    );
    this.savedetails.start();

    this.#searchEfaQuery$
      .pipe(
        debounceTime(SharedConstant.SEARCH_DEBOUNCE_TIME),
        filter(
          (key: string) =>
            !!key && key.length >= SharedConstant.TEXT_MIN_LENGTH_2
        ),
        switchMap(() => this.#fetchEfaDetails()),
        takeUntil(this.#unsubscriber$)
      )
      .subscribe({
        next: (response: GlobalEngEfaModelWithPagination) => {
          this.efaTotalCount = response.totalCount;
          this.#postEfaFetch(response);
        },
        error: (error: HttpErrorResponse) => {
          this.isEfaSpinnerVisible = false;
          console.error('error', error);
        },
      });
  }

  #fetchEfaDetails(): Observable<GlobalEngEfaModelWithPagination> {
    this.isEfaSpinnerVisible = true;
    return this.globalEngagementService.getEFARoles(
      this.pageNumber,
      this.efaSelected ?? this._BLANK
    );
  }

  #fetchEfaAllDetails(callfrom: number): void {
    const result = this.#fetchEfaDetails();
    if (callfrom === CallFromEnum.fromScroll) {
      this.onScrollDataLoadInProgress = true;
      result.pipe(takeUntil(this.#unsubscriber$)).subscribe({
        next: (response: GlobalEngEfaModelWithPagination) => {
          this.#postEfaFetch(response);
        },
        error: (error: HttpErrorResponse) => {
          this.isEfaSpinnerVisible = false;
          console.error('error', error);
        },
      });
    }
  }

  #postEfaFetch(response: GlobalEngEfaModelWithPagination): void {
    if (response) {
      if (
        this.efaTotalCount === 0 &&
        response.globalEngagementRoleConfigResponse.length == 0
      ) {
        this.showEfaDropdown = true;
        this.efaNotFound = GlobalEngagementsConstant.NO_MATCHES_FOUND;
      } else if (this.efaTotalCount > 0) {
        const result: GlobalEngEfaModel[] =
          response.globalEngagementRoleConfigResponse;
        if (result) {
          this.efaArr.push(...result);
          this.totalSearchResultLoaded = this.efaArr.length;
        }
        this.efaNotFound = this._BLANK;
        this.showEfaDropdown = true;
      }
      this.isEfaSpinnerVisible = false;
      this.onScrollDataLoadInProgress = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.commonService.enableAuditTrail(true);
    if (changes['submissionId']) {
      this.getSubmissionDetails();
      this.globalEngagementService.changeSubmissionId({
        opportunitynumber: this.engagementId!,
        submissionid: this.submissionId,
      });
    }
  }

  openModalForDiscontinue(modalBtn?: ButtonComponent): void {
    const globalEngagementDisContinueModalRef = this.modalService.open(
      DiscontinuePopupComponent,
      {
        isFooter: false,
        size: 'lg',
        isInverse: false,
        submissionId: this.submissionId,
      }
    );
    globalEngagementDisContinueModalRef
      .onClosed()
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe(() => {
        if (this.submissionId) {
          this.timeoutId = setTimeout(() => {
            this.getSubmissionDetails();
          }, 1000);
        }
        this.globalEngagementService.openDiscontinueModal(false);
      });
  }

  openModalForResetStatus(modalBtn?: ButtonComponent): void {
    const globalEngagementResetStatusModalRef = this.modalService.open(
      GlobalEngResetStatusComponent,
      {
        isFooter: false,
        size: 'lg',
        isInverse: false,
        submissionId: this.submissionId,
        submissionStatus: this.submissionStatus,
      }
    );
    globalEngagementResetStatusModalRef
      .onClosed()
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe(() => {
        if (this.submissionId) {
          this.timeoutId = setTimeout(() => {
            this.getSubmissionDetails();
            this.loadLeftMenu.emit(this.engagementId);
          }, 2000);
        }
        this.globalEngagementService.openResetStatusModal(false);
      });
  }

  getSubmissionDetails(): void {
    this.progressIndicator.show();
    this.globalEngagementService
      .getGlobalEngagementSubmissionDetails(Number(this.submissionId))
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: (response: GlobalEngagementSubmissionDetailModel) => {
          this.submissionDetails = response;
          this.isEngagementDetailsFormValid.emit(
            response.isEngagementDetailsCompleted
          );
          this.setVariables();
          this.isWbsArchiveEditProgress =
            this.submissionDetails.chargeCode === null ||
            this.submissionDetails.archiveNumber !== null;
          this.progressIndicator.hide();
          if (this.submissionId !== null) {
            this.SubmissionActionHistoryForAdminComplete(this.submissionId);
          }
          this.globalEngagementService.enableDisconitnue(
            this.isSubmissionStatusDraft()
          );
          this.globalEngagementService.enableResetStatus(
            this.isSubmissionStatusForReset()
          );
        },
        error: (err: HttpErrorResponse) => {
          console.error('An error occurred during submission: ', err);
          this.progressIndicator.hide();
        },
      });
  }

  SubmissionActionHistoryForAdminComplete(id: number): void {
    this.globalEngagementService
      .getSubmissionActionHistory(id)
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: (response: SubmissionActionHistoryModel[]) => {
          this.submissionActionHistory = response;
          for (let i in this.submissionActionHistory) {
            if (
              this.submissionActionHistory[i].currentStatus ===
              StatusEnum.DISCONTINUED
            ) {
              this.showDiscontinueMessage = true;
              this.discontinueActionMessage = this.submissionActionHistory[i];
              this.loadLeftMenu.emit(this.engagementId);
              return;
            } else if (
              this.submissionActionHistory[i].currentStatus ===
              StatusEnum.COMPLETED_ADMIN
            ) {
              // TODO: For admin complete
            } else if (
              this.submissionActionHistory[i].submissionActionId ===
              GlobalEngagementsConstant.RESET_ACTION_ID
            ) {
              this.showResetActionMessage = true;
              this.resetActionMessage = this.submissionActionHistory[i];
              return;
            } else {
              this.showDiscontinueMessage = false;
              this.isShowMoreDocumentNotes = false;
            }
          }
        },
        error: (err: HttpErrorResponse) => {
          this.progressIndicator.hide();
          console.error('Error fetching data', err);
        },
      });
  }

  isSubmissionStatusDraft(): boolean {
    return (
      (this.submissionStatus as GlobalEngagementSubmissionDocumentStatus) ===
      GlobalEngagementSubmissionDocumentStatus.DRAFT
    );
  }

  isSubmissionStatusForReset(): boolean {
    return (
      (this.submissionStatus as GlobalEngagementSubmissionDocumentStatus) ===
        GlobalEngagementSubmissionDocumentStatus.COMPLETED ||
      (this.submissionStatus as GlobalEngagementSubmissionDocumentStatus) ===
        GlobalEngagementSubmissionDocumentStatus.DISCONTINUED ||
      (this.submissionStatus as GlobalEngagementSubmissionDocumentStatus) ===
        GlobalEngagementSubmissionDocumentStatus.COMPLETED_ADMIN
    );
  }

  checkStatusDiscontinued(): boolean {
    return this.submissionStatus === StatusEnum.DISCONTINUED;
  }

  clickToShowDocumentMoreLepMessage(): void {
    this.isShowMoreDocumentNotes = !this.isShowMoreDocumentNotes;
    if (!this.isShowMoreDocumentNotes) {
      this.showMoreText = IntakeConstant.SHOW_MORE_TEXT;
      this.showMoreOptions.icon = IntakeConstant.DDS_ICON_ARROW_DOWN;
    } else {
      this.showMoreText = IntakeConstant.SHOW_LESS_TEXT;
      this.showMoreOptions.icon = IntakeConstant.DDS_ICON_ARROW_UP;
    }
  }

  setVariables(): void {
    this.isEngagementDetailsCompleted =
      this.submissionDetails?.isEngagementDetailsCompleted ?? false;
    this.engagementTitle = this.submissionDetails?.submissionTitle;
    this.notes = this.submissionDetails?.notes;
    this.submissionTypeId = this.submissionDetails?.submissionTypeId;
    this.submissionStatusId = this.submissionDetails?.submissionStatusId;
    this.wbsArchiveFormdata.chargeCode =
      this.submissionDetails?.chargeCode ?? this._BLANK;
    this.wbsArchiveFormdata.wbsDescription =
      this.submissionDetails?.wbsDescription ?? this._BLANK;
    this.wbsArchiveFormdata.archiveNumber =
      this.submissionDetails?.archiveNumber ?? this._BLANK;
    this.wbsArchiveFormdata.archiveName =
      this.submissionDetails?.archiveName ?? this._BLANK;
    this.wbsArchiveFormdata.archiveDescription =
      this.submissionDetails?.archiveDescription ?? this._BLANK;
    this.wbsArchiveFormdata.archiveStatus =
      this.submissionDetails?.archiveStatus ?? this._BLANK;
    this.wbsArchiveFormdata.archiveFolder =
      this.submissionDetails?.archiveFolder ?? this._BLANK;
    this.wbsArchiveFormdata.archiveFoldersArray =
      this.submissionDetails?.archiveFoldersArray ?? [];
    this.wbsArchiveFormdata.business =
      this.submissionDetails?.business ?? this._BLANK;
    this.wbsArchiveFormdata.clientNumber =
      this.submissionDetails?.clientNumber ?? this._BLANK;
    this.wbsArchiveFormdata.clientName =
      this.submissionDetails?.clientName ?? this._BLANK;
    this.wbsArchiveFormdata.archiveID =
      this.submissionDetails?.archiveId ?? this._BLANK;
    this.wbsArchiveFormdata.partner =
      this.submissionDetails?.partner ?? this._BLANK;
    this.efaSelectedId = this.submissionDetails?.efa;
    this.efaSelected = this.submissionDetails?.efaName ?? this._BLANK;
    this.isWbsAvailable =
      this.submissionDetails?.isArchiveNotAvailable ?? false;
    this.submissionStatus =
      this.submissionStatusId !== undefined
        ? getStatusEnumKeyByValue(this.submissionStatusId) ?? null
        : null;
  }

  copyToClipboard(value: string | null): void {
    if (value) {
      copyToClipboard(value);
    }
  }

  makeFieldEditable(field: string): void {
    switch (field) {
      case 'engagementTitle':
        this.isEngagementTitleEditable = true;
        break;
      case 'efa':
        this.isEfaEditable = true;
        break;
      default:
        this.isEngagementTitleEditable = false;
        this.isEfaEditable = false;
        break;
    }
  }

  postEngagementDetails(): void {
    const requestBody = {
      SubmissionId: this.submissionDetails?.submissionId,
      EngagementId: this.submissionDetails?.engagementId,
      SubmissionTypeId: this.submissionDetails?.submissionTypeId,
      SubmissionStatusId: this.submissionDetails?.submissionStatusId,
      SubmissionTitle: this.engagementTitle,
      chargeCode: this.wbsArchiveFormdata?.chargeCode ?? this._BLANK,
      wbsDescription: this.wbsArchiveFormdata?.wbsDescription ?? this._BLANK,
      archiveNumber: this.wbsArchiveFormdata?.archiveNumber ?? this._BLANK,
      archiveName: this.wbsArchiveFormdata?.archiveName ?? this._BLANK,
      archiveDescription:
        this.wbsArchiveFormdata?.archiveDescription ?? this._BLANK,
      archiveStatus: this.wbsArchiveFormdata?.archiveStatus ?? this._BLANK,
      archiveFolder: this.wbsArchiveFormdata?.archiveFolder ?? this._BLANK,
      archiveFoldersArray: this.wbsArchiveFormdata?.archiveFoldersArray,
      business: this.wbsArchiveFormdata?.business ?? this._BLANK,
      clientNumber: this.wbsArchiveFormdata?.clientNumber ?? this._BLANK,
      clientName: this.wbsArchiveFormdata.clientName ?? this._BLANK,
      archiveId: this.wbsArchiveFormdata.archiveID ?? this._BLANK,
      partner: this.wbsArchiveFormdata.partner ?? this._BLANK,
      Notes: this.notes,
      ArchiveDocumentId: this.submissionDetails?.archiveDocumentId,
      Efa: this.efaSelectedId,
    };

    this.globalEngagementService
      .putGlobalEngagementSubmission(requestBody)
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
      next: () => {
        this.loadLeftMenu.emit(this.engagementId);
      },
      error: (err: HttpErrorResponse) => {
        console.error('An error occurred during submission: ', err);
      },
      });
  }

  onEfaSelect(event: GlobalEngEfaModel): void {
    this.efaSelectedId = String(event.employeeId);
    this.efaSelected = event.name;
    this.isEfaEditable = false;
    this.postEngagementDetails();
  }

  fetchMoreEfaResult(event: any) {
    if (
      !this.onScrollDataLoadInProgress &&
      event.target.offsetHeight + event.target.scrollTop >=
        event.target.scrollHeight
    ) {
      if (this.totalSearchResultLoaded < this.efaTotalCount) {
        this.pageNumber++;
        this.#fetchEfaAllDetails(CallFromEnum.fromScroll);
      }
    }
  }

  wbsOrArchiveChange(
    eventData: WbsWithArchiveDetailsModelForGlobalEngagements
  ) {
    this.wbsArchiveFormdata = eventData;
    this.postEngagementDetails();
  }

  isArchiveBtnDisabled(): boolean {
    const isButtonEnable: boolean | undefined =
      this.isEngagementDetailsCompleted &&
      this.permissionObj[
        'GLOBAL_ENG_SubmissionDetails_ArchiveAndComplete_Enable'
      ] &&
      hasValue(this.engagementTitle) &&
      hasValue(this.efaSelectedId) &&
      hasValue(this.efaSelected) &&
      !this.isEfaEditable &&
      hasValue(this.wbsArchiveFormdata?.wbsDescription) &&
      hasValue(this.wbsArchiveFormdata?.chargeCode) &&
      hasValue(this.wbsArchiveFormdata?.archiveNumber) &&
      this.totalDocCount > 0 &&
      !this.isWbsArchiveEditProgress;
    if (this.lastButtonEnableStatus !== isButtonEnable) {
      this.lastButtonEnableStatus = isButtonEnable;
      this.isValidForm.emit({
        formStatus: isButtonEnable ?? false,
        submissionId: this.submissionId ?? 0,
      });
    }
    return !isButtonEnable;
  }

  archiveAndComplete(): void {
    if (!this.isArchiveBtnDisabled()) {
      if (
        hasValue(this.submissionId) &&
        hasValue(this.engagementId) &&
        this.submissionId != null &&
        this.engagementId !== null
      ) {
        this.progressIndicator.show();
        this.globalEngagementService
          .updateSubmissionStatus({
            submissionId: this.submissionId,
            submissionStatusId:
              GlobalEngagementSubmissionStatusMapper[
                GlobalEngagementSubmissionDocumentStatus.COMPLETED
              ],
          })
          .pipe(takeUntil(this.#unsubscriber$))
          .subscribe({
            next: () => {
              this.toastService.createToast({
                ...GlobalEngagementsConstant.TOAST_OPTIONS,
                title: 'Completed',
              });
              this.timeoutId = setTimeout(() => {
                this.router.navigate(['/']);
              }, GlobalEngagementsConstant.DELAY_TIMER);
              this.progressIndicator.hide();
            },
            error: (err: HttpErrorResponse) => {
              this.progressIndicator.hide();
              console.error(
                'An error occurred updating document status as completed with archiveid : ',
                err
              );
            },
          });
      }
    }
  }

  getAllUploadedDocuments(event: GlobalDocumentTableModel[]): void {
    this.totalDocCount = event.length;
  }

  wbsArchiveEditProgress(event: boolean) {
    this.isWbsArchiveEditProgress = event;
  }

  transformStatusStyle(status: string | null): StatusEnum {
    return (
      Object.values(StatusEnum).find((enumValue) => enumValue === status) ||
      StatusEnum.Draft
    );
  }

  fieldEfaCleared(): void {
    this.efaSelected = this._BLANK;
    this.showEfaDropdown = false;
    this.efaNotFound = this._BLANK;
  }

  findEfa(event: string): void {
    if (
      event.length > SharedConstant.TEXT_MIN_LENGTH_2 &&
      event !== this._BLANK
    ) {
      this.showEfaDropdown = true;
      this.pageNumber = 1;
      this.isEfaSpinnerVisible = true;
      this.efaArr = [];
      this.#searchEfaQuery$.next(event);
    } else {
      this.efaNotFound = this._BLANK;
      this.showEfaDropdown = false;
    }
  }

  ngOnDestroy(): void {
    this.#unsubscriber$.next();
    this.#unsubscriber$.complete();
  }
}
